import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { RichText } from './RichText';
import { mainNav, legalNav } from '../data/navigation';
import { company } from '../data/company';
export function Footer() {
  return <footer className="border-t border-line bg-canvas" data-id="element-32" data-mp="32lrk57wamnhc">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-33" data-mp="36oo5359b2vog">
        <div className="max-w-sm" data-id="element-34" data-mp="3ug3e1gvl8b8o">
          <Logo data-id="element-35" data-mp="3uftpzyu3se5m" />
          <p className="mt-4 text-sm leading-relaxed text-muted" data-id="element-36" data-mp="3ud7ddkscv8gj">
            Digital educational resources for instructors and professionals. All products are delivered electronically — nothing is shipped.
          </p>
          <p className="mt-4 text-sm text-muted" data-id="element-37" data-mp="3qcxbokblj47h">
            <RichText text={company.email} data-id="element-38" data-mp="3qblwlocpaa12" />
          </p>
        </div>
        <nav aria-label="Company" data-id="element-39" data-mp="29y5g5yj5lgty">
          <h2 className="text-sm font-semibold text-ink" data-id="element-40" data-mp="2a19u3nmf7qxt">Company</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-41" data-mp="2ez1kuebbx70f">
            {mainNav.map(item => <li key={item.to} data-id="element-42" data-mp="3l8qx26bccnsi">
                <Link to={item.to} className="text-sm text-muted transition-colors duration-150 hover:text-ink" data-id="element-43" data-mp="3l9sjf6xt4wpj">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
        <nav aria-label="Legal" data-id="element-44" data-mp="3v5dhitzr9cu0">
          <h2 className="text-sm font-semibold text-ink" data-id="element-45" data-mp="3q8dj9595dedg">Policies</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-46" data-mp="830ibgbgg0zf">
            {legalNav.map(item => <li key={item.to} data-id="element-47" data-mp="80ns6fvjmkba">
                <Link to={item.to} className="text-sm text-muted transition-colors duration-150 hover:text-ink" data-id="element-48" data-mp="34gyblgf8z9p">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>
      <div className="border-t border-line" data-id="element-49" data-mp="cu8uul8302gt">
        <p className="mx-auto max-w-6xl px-5 py-6 text-xs text-muted sm:px-8" data-id="element-50" data-mp="qt8ibpjuybbe">
          © {new Date().getFullYear()} {company.legalName}. All rights reserved.
        </p>
      </div>
    </footer>;
}